import { NamedThing } from "../../web/src/types";
import { IdentifyableObject } from "../../web/src/providers/data/data-store";

export function getOrCreate<T>(map: { [name: string]: T }, name: string, create: () => T): T {
    const value = map[name];
    if (value) {
        return value;
    }
    else {
        return (map[name] = create());
    }
}

export function namedThingsComparer(a: NamedThing, b: NamedThing) {
    return getNormalizedNameForSorting(a).localeCompare(getNormalizedNameForSorting(b), 'de-DE');
}

export function getSortedIndexItemComparer() {
    return (a: IdentifyableObject, b: IdentifyableObject) => a.$sortOrder - b.$sortOrder;
}

export function getNormalizedNameForSorting(thing: NamedThing) {
    return thing.name.toLowerCase().replace(/β/gu, 'b');
}



// WEBPACK FOOTER //
// ../data/compiler/util.ts